module.exports = __webpack_public_path__ + "img/react-dark.2fde5475.svg";